import PropTypes from "prop-types";
import HeadMetadata from "app/utils/metas/HeadMetadata";
import { getPrefetchedPhotos } from "app/pages/Listing/productsSelector";
import { connect } from "react-redux";
import { getRobotsMetaTag } from "app/reducers/partnerSelector";

const ListingHeadMetadata = ({
	prefetchedPhotos = [],
	robotsMetaTag = [],
	title: titleFromProps,
	description: descriptionFromProps,
	titleFromSanity,
	descriptionFromSanity,
}) => {
	const title = titleFromSanity || titleFromProps;
	const description = descriptionFromSanity || descriptionFromProps;

	return (
		<HeadMetadata
			prefetchRessources={prefetchedPhotos}
			robotsMetaTag={robotsMetaTag}
			title={title}
			description={description}
		/>
	);
};

ListingHeadMetadata.propTypes = {
	prefetchedPhotos: PropTypes.array,
	robotsMetaTag: PropTypes.array,
	title: PropTypes.string,
	description: PropTypes.string,
	titleFromSanity: PropTypes.string,
	descriptionFromSanity: PropTypes.string,
};

const mapStateToProps = state => {
	const robotsMetaTag = getRobotsMetaTag(state);

	return {
		prefetchedPhotos: getPrefetchedPhotos(state),
		robotsMetaTag: robotsMetaTag?.listing,
		titleFromSanity: state.brand?.seo?.listing?.metaTitle,
		descriptionFromSanity: state.brand?.seo?.listing?.metaDescription,
	};
};

export default connect(mapStateToProps)(ListingHeadMetadata);
